import { Controller } from '@hotwired/stimulus'

// Opens a modal located elsewhere in the page by adding a class to it.
//
// Usage:
//   <button data-controller="modal-trigger"
//           data-modal-trigger-target-value="#add-modal"
//           data-modal-trigger-open-class-value="modal-open"
//           data-action="modal-trigger#open">
//     Ajouter
//   </button>
export default class extends Controller {
  static values = {
    target: String,
    openClass: { type: String, default: 'modal-open' }
  }

  open() {
    const modal = document.querySelector(this.targetValue)
    if (modal) modal.classList.add(this.openClassValue)
  }
}
